import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberHorizontalToward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronGrabberHorizontalToward"><Path d="M10.3105 12L5.25 17.0605L4.18945 16L8.18945 12L4.18945 8L5.25 6.93945L10.3105 12Z" fill="currentColor"/><Path d="M19.8105 8L15.8105 12L19.8105 16L18.75 17.0605L13.6895 12L18.75 6.93945L19.8105 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronGrabberHorizontalToward;
